import React, {Component} from 'react'
import {connect} from 'react-redux'
import {actions} from 'react-redux-form'
import {Grid, Row, Col} from 'react-bootstrap'
import EditCategoryForm from './category-edit-form'
import BackLink from '../../../../common/back-link/index'
import PageTitle from "../../../../common/page-title/index";
import {getCategory} from '../../../../../actions/categories'

// import './styles.css'

class EditCategory extends Component {

  constructor(props){
    super(props);
  }

  componentWillMount() {
    const id = +this.props.match.params.id;
    if(id){
      this.props.dispatch(getCategory(id));
    }
  }

  componentWillUnmount(){
    this.props.dispatch(actions.reset('deep.admin_category'));
    this.props.dispatch({type: 'CLEAR_EDIT_CATEGORY'});
  }

  render(){
    return(
      <Grid bsClass="container" fluid className="categories">
        <Row>
          <Col lg={12}>
            <BackLink href="/admin/categories"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <PageTitle>Add/Edit category</PageTitle>
          </Col>
        </Row>
        <EditCategoryForm category={this.props.category}/>
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    category: state.categories.category,
    fetched: state.categories.fetched,
    fetching: state.categories.fetching,
  };
};

export default connect(mapStateToProps)(EditCategory);



// WEBPACK FOOTER //
// ./src/components/admin/products/categories/edit/index.jsx